import { render } from "./Mailings.vue?vue&type=template&id=2739e11d&scoped=true"
import script from "./Mailings.vue?vue&type=script&lang=js"
export * from "./Mailings.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2739e11d"

export default script